export const DESTINATIONS_SHOWCASE_STYLES = {
  root: "relative w-full min-w-0 overflow-hidden bg-white rounded-[24px] shadow-component border border-ticketon-light-gray-bg p-2 pb-8 md:p-6 md:pb-12",
  imageWrapper: "relative min-h-[395px] w-full md:min-h-[340px] rounded-[20px] overflow-hidden mb-[-45px] md:mb-[-80px]",
  image: "absolute inset-0 h-full w-full object-cover",
  overlay:
    "absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/70",
  content:
    "relative z-10 flex h-full min-h-[395px] md:min-h-[340px] flex-col justify-end p-6 md:p-10 pb-8 md:pb-16",
  header: "max-w-md text-white",
  title: "text-[28px] md:text-[32px] font-bold leading-tight",
  description: "mt-2 text-[16px] font-normal opacity-100 [&>span]:font-bold",
  grid: "relative z-20 flex overflow-x-auto gap-2 md:grid md:grid-cols-3 lg:grid-cols-5 md:gap-4 lg:gap-6 px-3 md:px-10 pt-6 md:pt-12 scrollbar-hide",
  thumbLink: "group flex flex-col gap-1 flex-shrink-0 w-[144px] md:w-auto",
  thumbImageWrapper:
    "relative aspect-[5/6] md:aspect-[5/4] overflow-hidden rounded-[18px] shadow-lg bg-white",
  thumbImage:
    "h-full w-full object-cover transition-transform duration-300 group-hover:scale-110",
  thumbLocation: "text-[12px] text-ticketon-gray-600 font-semibold",
  thumbName: "text-[20px] font-bold text-primary leading-snug",
} as const;
